/**
 * Cart Gewinnspiel checkbox: updates cart attributes when toggled
 */
(function () {
  const ATTR_KEY = 'gewinnspiel';

  function updateCartAttribute(checked) {
    if (typeof window.routes === 'undefined' || !window.routes.cart_update_url) return;

    const body = JSON.stringify({
      attributes: { [ATTR_KEY]: checked ? '1' : '' },
    });

    fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body,
    }).catch((err) => console.error('Gewinnspiel cart attribute update failed:', err));
  }

  function init() {
    document.querySelectorAll('[data-cart-gewinnspiel-input]').forEach((input) => {
      if (input.dataset.cartGewinnspielInit) return;
      input.dataset.cartGewinnspielInit = '1';

      input.addEventListener('change', function () {
        updateCartAttribute(this.checked);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(init, 0);
    });
  }
})();
